import { REPORT_PATH } from "../const";

export const REPORT_EDIT_PAGE = "edit";
export const REPORT_EDIT_PATH = `${REPORT_PATH}/${REPORT_EDIT_PAGE}`;
